import axiosInstance from "../instance";

// Get All Categories
const fetchBanners = async () => {
    const response = await axiosInstance.get('/banners');
    return response.data;
}

const addBanners = async (formData) => {
    const response = await axiosInstance.post('/banners', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    // return response.data;
}

const deleteBanner = async (bannerId, image) => {

    console.log('delet category');
    console.log(bannerId);

    const response = await axiosInstance.delete('/banner', { params: { bannerId, image } });
}

export { fetchBanners, addBanners, deleteBanner };